/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { FractionDependencies } from './dependenciesFractionClass.generated';
import { createTyped } from '../../factoriesAny.js';
export var typedDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  ComplexDependencies: ComplexDependencies,
  DenseMatrixDependencies: DenseMatrixDependencies,
  FractionDependencies: FractionDependencies,
  createTyped: createTyped
};